export default __webpack_public_path__ + "static/2020-28bf3be8c998d28f9cfbbcb8ba35a11d.jpg";